import React, { useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {setUser } from './actions/index';
import Footer from './components/general/Footer';
import Login from './components/general/Login';
import Home from './components/Home';
import './variables.css';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const User = useSelector((state) => state.auth);

    // Restaura el estado del usuario desde sessionStorage al cargar la app
    useEffect(() => {
      const savedUser = JSON.parse(sessionStorage.getItem('user'));
      if (savedUser) {
        dispatch(setUser(savedUser)); // Restaura el usuario
      }
    }, [dispatch]);
  
    // Guarda los datos del usuario en sessionStorage cada vez que cambien
    useEffect(() => {
      if (User.user) {
        sessionStorage.setItem('user', JSON.stringify(User.user));
        if (User.user.Id_Access === 1) {
          //alert('Bienvenido a la página de administrador, aqui podras ver y modificar los datos de la empresa y los usuarios');
        }else{
          alert('No tienes permisos para acceder a esta página');
        }
      } else {
        sessionStorage.removeItem('user'); // Limpia sessionStorage si el usuario cierra sesión
      }
    }, [User.user]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={User.isAuthenticated && User.user.Id_Access && User.user.Id_Access=== 1 ?  <Navigate to='/home'/> : <Navigate to='/login'/>} />
          <Route path="/login" element={User.isAuthenticated && User.user.Id_Access && User.user.Id_Access=== 1 ? <Navigate to='/home'/> : <Login />} />
          <Route path="/home" element={User.isAuthenticated && User.user.Id_Access && User.user.Id_Access=== 1 ? <Home /> : <Navigate to='/login'/>} />
          <Route path="*" element={User.isAuthenticated && User.user.Id_Access && User.user.Id_Access=== 1 ?  <Navigate to='/home'/> : <Navigate to='/login'/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
